/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Accolade } from './Accolade';
import {
    AccoladeFromJSON,
    AccoladeFromJSONTyped,
    AccoladeToJSON,
    AccoladeToJSONTyped,
} from './Accolade';

/**
 * 
 * @export
 * @interface CreateAccoladeOutputBody
 */
export interface CreateAccoladeOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof CreateAccoladeOutputBody
     */
    readonly $schema?: string;
    /**
     * 
     * @type {Accolade}
     * @memberof CreateAccoladeOutputBody
     */
    accolade: Accolade;
}

/**
 * Check if a given object implements the CreateAccoladeOutputBody interface.
 */
export function instanceOfCreateAccoladeOutputBody(value: object): value is CreateAccoladeOutputBody {
    if (!('accolade' in value) || value['accolade'] === undefined) return false;
    return true;
}

export function CreateAccoladeOutputBodyFromJSON(json: any): CreateAccoladeOutputBody {
    return CreateAccoladeOutputBodyFromJSONTyped(json, false);
}

export function CreateAccoladeOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccoladeOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accolade': AccoladeFromJSON(json['accolade']),
    };
}

export function CreateAccoladeOutputBodyToJSON(json: any): CreateAccoladeOutputBody {
    return CreateAccoladeOutputBodyToJSONTyped(json, false);
}

export function CreateAccoladeOutputBodyToJSONTyped(value?: Omit<CreateAccoladeOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accolade': AccoladeToJSON(value['accolade']),
    };
}

